import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import { DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import BriefCaseIcon27pxSvg from "../../../assets/images/icons/BriefCaseIcon27pxSvg";
import InfoIcon16pxSvg from "../../../assets/images/icons/InfoIcon16pxSvg";
import QuestionIcon20pxSvg from "../../../assets/images/icons/QuestionIcon20pxSvg";
import avatar_default from "../../../assets/images/logo/avatar-default-logo.png";
import my_company_logo from "../../../assets/images/logo/my-company-logo.png";
import ProgressPassword from "../../../components/ProgressPassword";
import {
  ControlpanelPrimaryButton,
  ControlpanelSecondaryButton,
  GrayIconButton,
} from "../../../components/StyledButton";
import { CustomDialog } from "../../../components/StyledComponents";
import { StyledLinkBlue } from "../../../components/StyledLink";
import CustomCropImage from "../../ControlPanel/CustomCropImage/CustomCropImage";
import SwapIcon14pxSvg from "./../../../assets/images/icons/SwapIcon14pxSvg";
import UsersGroupIcon27pxSvg from "./../../../assets/images/icons/UsersGroupIcon27pxSvg";
import { useAuth } from "../../../context/AuthContext";
import { switchCompany } from "../../../axios/Company/CompanyApi";
import { toast } from "react-toastify";
import { useLoading } from "../../../context/LoadingContext";
import Tooltip from "@mui/material/Tooltip";
import UserSecretIcon16pxSvg from "../../../assets/images/icons/UserSecretIcon16pxSvg";
import UserIcon21x20pxSvg from "../../../assets/images/icons/UserIcon21x20pxSvg";

const LoginOptionsDialog = ({ onClose, listAccountCompany }) => {
  const { t } = useTranslation();
  const { profile, setStatusSwitch, refreshProfile } = useAuth();
  const [show, hide] = useLoading();

  const [selectedItem, setSelectedItem] = useState(null);
  const [accountLogin, setAccountLogin] = useState(null);

  const handleItemClick = (item) => {
    setSelectedItem(item === selectedItem ? null : item);
  };

  const handleSwitch = async (e) => {
    e.preventDefault();
    show();
    try {
      const payload = {
        ...selectedItem,
        langId: localStorage.getItem("i18nextLngId"),
      };
      const response = await switchCompany(payload);
      if (response.data.code === 200) {
        const code = response?.data?.data?.responseCode;
        if (code === undefined || code === 0) {
          // window.location.reload()
          setStatusSwitch(true);
          refreshProfile();
          // refreshProfileSwitch()

          // handelGetInfo(profile.email);
        } else {
          toast.error(response.data.data.message);
        }
      } else if (response.data.code === 500) {
        toast.error(response.data.message);
      } else {
        toast.error(
          response.data.data.responseCode
            ? response.data.data.message
            : response.data.data.fieldErrors[0]?.message
        );
      }
    } catch (error) {
      toast.error(error);
    } finally {
      hide();
    }
  };

  // const [prevImageUrl, setPrevImageUrl] = useState(my_company_logo);
  // const [imageUrl, setImageUrl] = useState(avatar_default);
  // const [isNewImageSelected, setIsNewImageSelected] = useState(false);

  // const resetDefaultPicture = () => {
  //    setImageUrl(avatar_default);
  // };

  // const imageInputRef = useRef(null);

  // const handleIconClick = () => {
  //    imageInputRef.current.click();
  // };

  useEffect(() => {
    if (listAccountCompany.length > 0 && profile?.companyId) {
      const matched = listAccountCompany.find(
        (item) =>
          item.companyId === profile.companyId &&
          (item.permissonId === 3 || item.permissonId === 2)
      );
      if (matched) {
        setAccountLogin(matched);
      }
    }
  }, [listAccountCompany, profile]);

  console.log("listAccountCompany: ", listAccountCompany)

  const userInfo = {
    adminName: "Phạm Xuân Khánh",
    companyName: "MOBILE-ID",
    groupAdministrators: [
      {
        groupName: "Tester",
        description: "Tester group",
      },
      {
        groupName: "Developer",
        description: "Developer group",
      },
    ],
    generalUser: "Khanh PX",
  };

  // const [formData, setFormData] = useState({
  //    password: '',
  // });

  // const handleInputChange = (e) => {
  //    const { name, value } = e.target;
  //    setFormData((prevData) => ({
  //       ...prevData,
  //       [name]: value,
  //    }));
  // };

  const handleCloseDialog = () => {
    onClose();
  };

  return (
    <CustomDialog maxWidth={"xl"} open onClose={handleCloseDialog} keepMounted>
      <DialogTitle>
        <div className="flex justify-between">
          <div className="flex items-center gap-4">
            <p className="text-xl font-semibold ">
              {t("navbar.login-options.title")}
            </p>
          </div>
          <GrayIconButton onClick={handleCloseDialog}>
            <CloseIcon />
          </GrayIconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className="switch-login">
          {listAccountCompany.some(
            (item) => item.permissonId === 3 && item.active === "ACTIVE"
          ) && (
            <div className="pt-5">
              <p className="text-sm font-semibold">
                {t("navbar.login-options.administrators")}
              </p>
              <div className="administrators grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
                {listAccountCompany
                  .filter(
                    (value) =>
                      value.permissonId === 3 && value.active === "ACTIVE"
                  )
                  .map((value, index) => (
                    <Tooltip
                      title={
                        <div>
                          <div>{value.fullName}</div>
                          <div>{value.companyName}</div>
                        </div>
                      }
                      placement="top"
                      arrow
                    >
                      <div
                        key={index}
                        className={`administrators-item text-sm ${
                          selectedItem === value ? "active" : ""
                        }
                                    ${
                                      accountLogin === value
                                        ? "login-account"
                                        : ""
                                    }`}
                        onClick={() => handleItemClick(value)}
                      >
                        <div className="w-[70%] flex flex-col gap-1">
                          <p className="text-ellipsis overflow-hidden font-semibold">
                            {value.fullName}
                          </p>
                          <p className="truncate whitespace-nowrap overflow-hidden font-normal">
                            {value.companyName}
                          </p>
                        </div>
                        <div className='administrators-item_bg-circle-icon'>
                                       <BriefCaseIcon27pxSvg />
                                    </div>
                        {/* <div className="">
                          {value.companyLogo ? (
                            <img
                              src={`data:image/jpeg;base64,${value.companyLogo}`}
                              alt="Company Logo"
                            />
                          ) : (
                            <BriefCaseIcon27pxSvg />
                          )}
                          <BriefCaseIcon27pxSvg />
                        </div> */}
                      </div>
                    </Tooltip>
                    // <div
                    //    key={index}
                    //    className={`administrators-item text-sm ${selectedItem === value ? 'active' : ''}
                    //    ${accountLogin === value ? 'login-account' : ''}`}
                    //    onClick={() => handleItemClick(value)}
                    //    title={`${value.fullName} - ${value.companyName}`}
                    // >
                    //    <div className='w-[70%] flex flex-col gap-1'>
                    //       <p className='text-ellipsis overflow-hidden font-semibold'>{value.fullName}</p>
                    //       <p
                    //          className='truncate whitespace-nowrap overflow-hidden font-normal'
                    //          // title={value.companyName}
                    //       >
                    //          {value.companyName}
                    //       </p>
                    //    </div>
                    //    <div className='administrators-item_bg-circle-icon'>
                    //       <BriefCaseIcon27pxSvg />
                    //    </div>
                    // </div>
                  ))}
              </div>
            </div>
          )}
          {/* <div className='pt-5 opacity-50 pointer-events-none'>
                  <p className='text-sm font-semibold'>{t('navbar.login-options.group-administrators')}</p>
                  <div className='group-administrators grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3'>
                     {userInfo.groupAdministrators.map((value, index) => (
                        <div
                           className={`group-administrators-item text-sm ${selectedItem === value.groupName ? 'active' : ''}`}
                           key={index}
                           onClick={() => handleItemClick(value.groupName)}
                        >
                           <div className='w-[70%] flex flex-col gap-1'>
                              <p className='text-ellipsis overflow-hidden font-semibold'>{value.groupName}</p>
                              <p className='text-ellipsis overflow-hidden font-normal'>{value.description}</p>
                              <p className='text-ellipsis overflow-hidden font-normal'>[{userInfo.companyName}]</p>
                           </div>
                           <div className='administrators-item_bg-circle-icon'>
                              <UsersGroupIcon27pxSvg />
                           </div>
                        </div>
                     ))}
                  </div>
               </div> */}
          {listAccountCompany.some(
            (item) => item.permissonId === 2 && item.active === "ACTIVE"
          ) && (
            <div className="pt-5">
              <p className="text-sm font-semibold">
                {t("navbar.login-options.general-users")}
              </p>
              <div className="administrators grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
                {listAccountCompany
                  .filter(
                    (value) =>
                      value.permissonId === 2 && value.active === "ACTIVE"
                  )
                  .map((value, index) => (
                    <Tooltip
                      title={
                        <div>
                          <div>{value.fullName}</div>
                          <div>{value.companyName}</div>
                        </div>
                      }
                      placement="top"
                      arrow
                    >
                      <div
                        key={index}
                        className={`administrators-item text-sm ${
                          selectedItem === value ? "active" : ""
                        }
                                 ${
                                   profile?.companyId === value.companyId
                                     ? "login-account"
                                     : ""
                                 }
                                 
                                 `}
                        onClick={() => handleItemClick(value)}
                      >
                        <div className="w-[70%] flex flex-col gap-1">
                          <p className="text-ellipsis overflow-hidden font-semibold">
                            {value.fullName}
                          </p>
                          <p
                            className="truncate whitespace-nowrap overflow-hidden font-normal"
                            // title={value.companyName}
                          >
                            {value.companyName}
                          </p>
                        </div>
                        {/* <div className="administrators-item_bg-circle-icon">
                          <UserIcon21x20pxSvg />
                        </div> */}
                        <div className="">
                          {/* {value.companyLogo ? (
                            <img
                              src={`data:image/jpeg;base64,${value.companyLogo}`}
                              alt="Company Logo"
                            />
                          ) : (
                            <div className="administrators-item_bg-circle-icon">
                              <UserIcon21x20pxSvg />
                            </div>
                          )} */}
                          <div className="administrators-item_bg-circle-icon">
                            <UserIcon21x20pxSvg />
                          </div>
                        </div>
                      </div>
                    </Tooltip>
                  ))}
              </div>
            </div>
          )}
          <div className="flex pt-5 gap-2 xl:items-center">
            <QuestionIcon20pxSvg className="!text-[#EAB308]" />
            <p className="text-[#EAB308] italic text-sm">
              {t(
                "navbar.login-options.current-user-profile-is-hightlighted-in-blue-color"
              )}
            </p>
          </div>
          {/* <div className='pt-5 flex justify-end gap-2'>
                  <ControlpanelPrimaryButton disabled={!selectedItem || selectedItem.companyId === profile?.companyId} onClick={handleSwitch}>
                     <SwapIcon14pxSvg />
                     <p>{t('button.switch')}</p>
                  </ControlpanelPrimaryButton>
               </div> */}
        </div>
        {/* <div className='change-password pt-6'>
               <p className='font-semibold text-sm'>{t('navbar.login-options.change-password')}</p>
               <div className='change-password-container'>
                  <div className='rounded-md bg-[#EFF6FF] p-4'>
                     <div className='flex items-center gap-2'>
                        <InfoIcon16pxSvg className='text-[#2563EB]' />
                        <p>
                           <span className='font-semibold'>{t('navbar.login-options.customer')} </span>({t('navbar.login-options.username')}
                           : khanhpx@mobile-id.vn)
                        </p>
                     </div>
                  </div>
                  <div className='bg-[#FEFCE8] p-3 text-[#A16207]'>
                     <p className='font-semibold text-sm'>{t('tool-tip.password.should-include')}</p>
                     <ul className='custom-dot-list'>
                        <li>{t('tool-tip.password.at-least-character')}</li>
                        <li>{t('tool-tip.password.at-least-letter')}</li>
                        <li>{t('tool-tip.password.none-english')}</li>
                     </ul>
                  </div>
                  <div>
                     <div className='grid grid-cols-10 pt-5'>
                        <p className='col-span-10 md:col-span-3 flex items-center text-sm'>{t('common.full-name')}</p>
                        <div className='col-span-10 md:col-span-7'>
                           <input type='text' className='form-control' />
                        </div>
                     </div>
                     <div className='grid grid-cols-10 pt-5'>
                        <p className='col-span-10 md:col-span-3 flex items-center text-sm'>{t('common.password')}</p>
                        <div className='col-span-10 md:col-span-7'>
                           <input
                              type='password'
                              className='form-control'
                              id='password'
                              name='password'
                              value={formData.password}
                              onChange={handleInputChange}
                           />
                        </div>
                     </div>
                     <div className='grid grid-cols-10 pt-5'>
                        <p className='col-span-10 md:col-span-3 flex items-center text-sm'>{t('common.confirm-password')}</p>
                        <div className='col-span-10 md:col-span-7'>
                           <input type='password' className='form-control' />
                        </div>
                     </div>
                     <div className='grid grid-cols-10 pt-3'>
                        <div className='col-span-10 md:col-span-3'></div>
                        <div className='col-span-10 md:col-span-7'>
                           <ProgressPassword value={formData.password} />
                        </div>
                     </div>
                     <div className='flex justify-end pt-4'>
                        <ControlpanelPrimaryButton disabled={true}>
                           <EditIcon />
                           <p>{t('button.update')}</p>
                        </ControlpanelPrimaryButton>
                     </div>
                  </div>
               </div>
            </div> */}
        {/* <div className='change-profile-picture pt-6'>
               <p className='text-sm font-semibold uppercase'>{t('navbar.login-options.change-profile-picture')}</p>
               <div className='flex pt-6 justify-between items-center'>
                  <p className='text-sm'>{t('common.profile-picture')}</p>
                  <div className='flex flex-col gap-5'>
                     <div className='self-end'>
                        <ControlpanelPrimaryButton onClick={handleIconClick}>
                           <SearchIcon />
                           <p>{t('button.browse')}</p>
                        </ControlpanelPrimaryButton>
                        <input type='file' ref={imageInputRef} className='hidden' onChange={handleImageChange} accept='image/*' />
                     </div>
                     <div className='flex flex-col justify-between'>
                        <StyledLinkBlue onClick={resetDefaultPicture} className='cursor-pointer'>
                           <p className='text-sm'>{t('common.reset-to-default-profile-picture')}</p>
                        </StyledLinkBlue>
                     </div>
                  </div>
               </div>
               <div className='pt-4'>
                  <div className='p-1 border-[1px] border-[#E5E7EB] rounded inline-block mt-4 self-end'>
                     <img src={prevImageUrl} alt='picture_profile' className='w-auto h-[200px]' />
                  </div>
               </div>
               <div className='pt-4'>
                  <CustomCropImage
                     imageUrl={imageUrl}
                     isNewImageSelected={isNewImageSelected}
                     setImageUrl={setImageUrl}
                     showBeginImage={true}
                  ></CustomCropImage>
               </div>
               <div className='pt-5'>
                  <div className='flex justify-end'>
                     <ControlpanelPrimaryButton disabled={true}>
                        <EditIcon />
                        <p>{t('button.update')}</p>
                     </ControlpanelPrimaryButton>
                  </div>
               </div>
            </div> */}
      </DialogContent>
      <DialogActions>
        <div className="flex gap-2 px-4 py-4">
          <ControlpanelSecondaryButton onClick={handleCloseDialog}>
            <CloseIcon />
            <p>{t("button.cancel")}</p>
          </ControlpanelSecondaryButton>
          <ControlpanelPrimaryButton
            disabled={
              !selectedItem || selectedItem.companyId === profile?.companyId
            }
            onClick={handleSwitch}
          >
            <SwapIcon14pxSvg />
            <p>{t("button.switch")}</p>
          </ControlpanelPrimaryButton>
        </div>
      </DialogActions>
    </CustomDialog>
  );
};

export default LoginOptionsDialog;
